import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unknown' },
    { value: 1, label: 'Not Provided' },
    { value: 2, label: 'No' },
    { value: 3, label: 'Yes' },
  ],
});
